// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { getFirestore, doc, getDoc } from 'firebase/firestore';
// import app from '../firebase';
// import { 
//   Star, 
//   MapPin, 
//   Mail, 
//   Phone, 
//   Calendar, 
//   Instagram, 
//   Facebook, 
//   Twitter, 
//   Linkedin,
//   Clock,
//   DollarSign,
//   ChevronRight,
//   Globe,
//   Users
// } from 'lucide-react';

// const PublicPreview = () => {
//   const { userName } = useParams();
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('services');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [websiteData, setWebsiteData] = useState(null);
  
//   useEffect(() => {
//     const fetchWebsite = async () => {
//       console.log('Starting to fetch website data for username:', userName);
//       setLoading(true);
//       setError(null);
//       try {
//         const db = getFirestore(app);
//         console.log('Firestore instance created');
        
//         // 1. Fetch userId from usernames collection
//         console.log('Attempting to fetch from usernames collection:', userName);
//         const usernameRef = doc(db, 'usernames', userName);
//         const usernameSnap = await getDoc(usernameRef);
//         console.log('Username document exists:', usernameSnap.exists());
        
//         if (!usernameSnap.exists()) {
//           console.log('Username not found in database');
//           setError('This username does not exist.');
//           setLoading(false);
//           return;
//         }
        
//         const userId = usernameSnap.data().uid;
//         console.log('Retrieved userId:', userId);
        
//         // 2. Fetch published website from publishedWebsite collection
//         console.log('Attempting to fetch from publishedWebsite collection:', userId);
//         const publishedRef = doc(db, 'publishedWebsite', userId);
//         const publishedSnap = await getDoc(publishedRef);
//         console.log('Published website document exists:', publishedSnap.exists());
        
//         if (!publishedSnap.exists()) {
//           console.log('Published website not found for userId:', userId);
//           setError('This coaching profile is not published yet.');
//           setLoading(false);
//           return;
//         }
        
//         // Process data - ensure all expected fields have values even if missing
//         const data = publishedSnap.data();
//         console.log('Raw published website data:', data);
        
//         // Ensure socialLinks exists
//         if (!data.socialLinks) {
//           console.log('No socialLinks found, creating default structure');
//           data.socialLinks = {
//             facebook: data.facebook || '',
//             instagram: data.instagram || '',
//             twitter: data.twitter || '',
//             linkedin: ''
//           };
//         }
        
//         console.log('Final processed website data:', data);
//         setWebsiteData(data);
//       } catch (err) {
//         console.error('Error fetching website data:', err);
//         console.error('Error details:', {
//           message: err.message,
//           code: err.code,
//           stack: err.stack
//         });
        
//         if (err.message && err.message.includes('Missing or insufficient permissions')) {
//           console.log('Permission error detected');
//           setError('This coaching profile is not available due to permission restrictions.');
//         } else {
//           console.log('Generic error occurred');
//           setError('An error occurred while loading this profile.');
//         }
//       } finally {
//         console.log('Fetch operation completed, setting loading to false');
//         setLoading(false);
//       }
//     };
    
//     if (userName) {
//       console.log('Username parameter found, initiating fetch');
//       fetchWebsite();
//     } else {
//       console.log('No username parameter found');
//     }
//   }, [userName]);

//   // Helper function to render stars for ratings
//   const renderStars = (rating = 5, maxRating = 5) => {
//     return (
//       <div className="flex items-center">
//         {[...Array(maxRating)].map((_, index) => (
//           <Star 
//             key={index} 
//             className={`w-4 h-4 ${index < rating ? 'text-amber-400 fill-amber-400' : 'text-gray-200'} mr-0.5`} 
//           />
//         ))}
//         <span className="text-gray-500 text-sm ml-2">({rating}.0)</span>
//       </div>
//     );
//   };

//   // Render social media icons
//   const renderSocialLinks = () => {
//     // Check for socialLinks object first
//     if (websiteData?.socialLinks) {
//       const { instagram, facebook, twitter, linkedin } = websiteData.socialLinks;
//       // Only render if at least one social link exists
//       if (instagram || facebook || twitter || linkedin) {
//         return (
//           <div className="flex space-x-4">
//             {instagram && (
//               <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//                 <Instagram className="h-5 w-5 text-green-600" />
//               </a>
//             )}
//             {facebook && (
//               <a href={`https://facebook.com/${facebook}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//                 <Facebook className="h-5 w-5 text-green-600" />
//               </a>
//             )}
//             {twitter && (
//               <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//                 <Twitter className="h-5 w-5 text-green-600" />
//               </a>
//             )}
//             {linkedin && (
//               <a href={`https://linkedin.com/in/${linkedin}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//                 <Linkedin className="h-5 w-5 text-green-600" />
//               </a>
//             )}
//           </div>
//         );
//       }
//     }
    
//     // Fallback to top-level social properties if socialLinks object isn't available
//     const { instagram, facebook, twitter } = websiteData || {};
//     // Only render if at least one direct social property exists
//     if (instagram || facebook || twitter) {
//       return (
//         <div className="flex space-x-4">
//           {instagram && (
//             <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//               <Instagram className="h-5 w-5 text-green-600" />
//             </a>
//           )}
//           {facebook && (
//             <a href={`https://facebook.com/${facebook}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//               <Facebook className="h-5 w-5 text-green-600" />
//             </a>
//           )}
//           {twitter && (
//             <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
//               <Twitter className="h-5 w-5 text-green-600" />
//             </a>
//           )}
//         </div>
//       );
//     }
    
//     return null;
//   };

//   // Render expertise areas as tags
//   const renderExpertiseTags = () => {
//     if (!websiteData?.expertiseAreas || websiteData.expertiseAreas.length === 0) return null;
    
//     return (
//       <div className="flex flex-wrap gap-2 mt-4">
//         {websiteData.expertiseAreas.map((expertise, index) => (
//           <span 
//             key={index} 
//             className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium"
//           >
//             {expertise.replace(/-/g, ' ')}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   // Render the services section
//   const renderServices = () => {
//     if (!websiteData?.services || websiteData.services.length === 0) {
//       // If services aren't available, show mock services as a fallback
//       const mockServices = [
//         {
//           id: '1',
//           title: 'Personal Life Coaching',
//           description: 'One-on-one sessions focused on achieving your personal goals and improving life satisfaction.',
//           duration: '60 min',
//           price: '$120'
//         },
//         {
//           id: '2',
//           title: 'Mental Health Support',
//           description: 'Supportive sessions to help manage stress, anxiety, and develop coping strategies.',
//           duration: '45 min',
//           price: '$90'
//         },
//         {
//           id: '3',
//           title: 'Wellness Consultation',
//           description: 'Holistic approach to improve your overall wellbeing and create sustainable healthy habits.',
//           duration: '90 min',
//           price: '$150'
//         }
//       ];
      
//       return (
//         <div className="space-y-6">
//           {mockServices.map((service) => (
//             <div 
//               key={service.id} 
//               className="border border-green-200 rounded-xl overflow-hidden hover:shadow-md transition-all transform hover:translate-y-[-2px] bg-white relative p-6"
//             >
//               <h3 className="text-xl font-medium text-green-900 mb-2">{service.title}</h3>
//               <p className="text-gray-600 mb-4">{service.description}</p>
//               <div className="flex flex-wrap gap-6">
//                 <div className="flex items-center text-gray-500 text-sm">
//                   <Clock className="w-4 h-4 mr-2" />
//                   {service.duration}
//                 </div>
//                 <div className="flex items-center text-gray-500 text-sm">
//                   <DollarSign className="w-4 h-4 mr-2" />
//                   {service.price}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     }
    
//     return (
//       <div className="space-y-6">
//         {websiteData.services.map((service, index) => (
//           <div 
//             key={service.id || index} 
//             className="border border-green-200 rounded-xl overflow-hidden hover:shadow-md transition-all transform hover:translate-y-[-2px] bg-white relative p-6"
//           >
//             <h3 className="text-xl font-medium text-green-900 mb-2">{service.title}</h3>
//             <p className="text-gray-600 mb-4">{service.description}</p>
//             <div className="flex flex-wrap gap-6">
//               {service.duration && (
//                 <div className="flex items-center text-gray-500 text-sm">
//                   <Clock className="w-4 h-4 mr-2" />
//                   {service.duration}
//                 </div>
//               )}
//               {websiteData.showPricing && service.price && (
//                 <div className="flex items-center text-gray-500 text-sm">
//                   <DollarSign className="w-4 h-4 mr-2" />
//                   {service.price}
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Render the testimonials section
//   const renderTestimonials = () => {
//     if (!websiteData?.testimonials || websiteData.testimonials.length === 0) {
//       // If testimonials aren't available, show mock testimonials as a fallback
//       const mockTestimonials = [
//         {
//           id: '1',
//           name: 'Sarah Johnson',
//           content: 'Dave helped me completely transform my approach to work-life balance. His guidance was exactly what I needed during a difficult career transition.',
//           rating: 5
//         },
//         {
//           id: '2',
//           name: 'Michael Torres',
//           content: 'The wellness program Dave created for me was perfectly tailored to my needs. I\'ve seen remarkable improvements in just a few months.',
//           rating: 5
//         },
//         {
//           id: '3',
//           name: 'Jessica Kim',
//           content: 'Working with Dave has been transformative for my mental health. His approach is compassionate, practical, and incredibly effective.',
//           rating: 5
//         }
//       ];
      
//       return (
//         <div className="grid gap-6 md:grid-cols-2">
//           {mockTestimonials.map((testimonial) => (
//             <div 
//               key={testimonial.id} 
//               className="border border-green-200 rounded-xl overflow-hidden hover:shadow-md transition-all transform hover:translate-y-[-2px] bg-white p-6"
//             >
//               {renderStars(testimonial.rating)}
//               <p className="text-gray-700 mt-3 italic">"{testimonial.content}"</p>
//               <p className="text-green-900 font-medium mt-2">— {testimonial.name}</p>
//             </div>
//           ))}
//         </div>
//       );
//     }
    
//     return (
//       <div className="grid gap-6 md:grid-cols-2">
//         {websiteData.testimonials.map((testimonial, index) => (
//           <div 
//             key={testimonial.id || index} 
//             className="border border-green-200 rounded-xl overflow-hidden hover:shadow-md transition-all transform hover:translate-y-[-2px] bg-white p-6"
//           >
//             {renderStars(testimonial.rating)}
//             <p className="text-gray-700 mt-3 italic">"{testimonial.content}"</p>
//             <p className="text-green-900 font-medium mt-2">— {testimonial.name}</p>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Render the location map section
//   const renderMapSection = () => {
//     // Always show map if location exists
//     if (!websiteData?.location) return null;
    
//     return (
//       <div className="mt-8 rounded-xl overflow-hidden">
//         <iframe 
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201064.14562241943!2d-122.57606278434371!3d37.7576171830618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1683214547570!5m2!1sen!2s"
//           width="100%" 
//           height="300" 
//           style={{border: 0}}
//           allowFullScreen="" 
//           loading="lazy" 
//           referrerPolicy="no-referrer-when-downgrade"
//           title="Location Map"
//           className="rounded-xl"
//         ></iframe>
//       </div>
//     );
//   };

//   // Render booking button
//   const renderBookingButton = () => {
//     // Always show booking button if calendarBookingPage exists
//     if (!websiteData?.calendarBookingPage) return null;
    
//     return (
//       <a 
//         href={websiteData.calendarBookingPage}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="px-6 py-3 bg-gradient-to-r from-green-600 to-green-800 text-white font-medium rounded-lg inline-flex items-center justify-center hover:shadow-lg transition-all w-full"
//       >
//         <Calendar className="w-5 h-5 mr-2" />
//         Book a Session
//       </a>
//     );
//   };

//   // Render contact information
//   const renderContactInfo = () => {
//     // Always show contact info since we have these fields in the payload
//     return (
//       <div className="flex flex-col space-y-4">
//         {websiteData?.email && (
//           <a href={`mailto:${websiteData.email}`} className="flex items-center text-gray-700 hover:text-gray-900 group">
//             <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
//               <Mail className="w-5 h-5 text-green-600" />
//             </div>
//             <span>{websiteData.email}</span>
//           </a>
//         )}
//         {websiteData?.phone && (
//           <a href={`tel:${websiteData.phone}`} className="flex items-center text-gray-700 hover:text-gray-900 group">
//             <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
//               <Phone className="w-5 h-5 text-green-600" />
//             </div>
//             <span>{websiteData.phone}</span>
//           </a>
//         )}
//         {websiteData?.website && (
//           <a href={websiteData.website} target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-gray-900 group">
//             <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
//               <Globe className="w-5 h-5 text-green-600" />
//             </div>
//             <span>Website</span>
//           </a>
//         )}
//         {websiteData?.location && (
//           <div className="flex items-center text-gray-700">
//             <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3">
//               <MapPin className="w-5 h-5 text-green-600" />
//             </div>
//             <span>{websiteData.location}</span>
//           </div>
//         )}
//       </div>
//     );
//   };

//   // Render active tab content
//   const renderActiveTabContent = () => {
//     switch(activeTab) {
//       case 'services':
//         return renderServices();
//       case 'testimonials':
//         return renderTestimonials();
//       default:
//         return renderServices();
//     }
//   };

//   // Loading state
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-green-50 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
//       </div>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <div className="min-h-screen bg-green-50 flex flex-col items-center justify-center p-4">
//         <div className="text-center max-w-md">
//           <h2 className="text-2xl font-bold text-green-800 mb-2">Profile Unavailable</h2>
//           <p className="text-gray-600 mb-6">{error}</p>
//           <button 
//             onClick={() => navigate('/')}
//             className="px-4 py-2 bg-green-600 text-white rounded-lg shadow-sm hover:bg-green-700 transition-colors"
//           >
//             Go Home
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // If no website data
//   if (!websiteData) {
//     return (
//       <div className="min-h-screen bg-green-50 flex items-center justify-center p-4">
//         <div className="text-center">
//           <h2 className="text-2xl font-bold text-green-800 mb-2">Coaching Profile Not Found</h2>
//           <p className="text-gray-600">This coaching profile doesn't exist or hasn't been published yet.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
//       {/* Hero Section */}
//       <header className="relative h-64 bg-gradient-to-r from-green-800 to-green-500 overflow-hidden text-white py-12">
//         <div className="absolute inset-0 opacity-20 bg-pattern"></div>
//         <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between">
//             <div className="md:w-2/3 mb-8 md:mb-0">
//               <h1 className="text-4xl font-light tracking-tight mb-4">
//                 {websiteData.name}
//               </h1>
//               <h2 className="text-xl text-green-100 mb-6">
//                 {websiteData.title || websiteData.profession || "Professional Coach"}
//               </h2>
//               <p className="text-green-100 mb-8 max-w-lg">
//                 {websiteData.bio}
//               </p>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main content */}
//       <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
//         <div className="md:flex md:gap-8">
//           {/* Left Column - Profile Info */}
//           <div className="md:w-1/3 -mt-24 relative z-20 mb-8 md:mb-0">
//             <div className="flex flex-col items-center bg-white rounded-2xl shadow-lg p-6 transform transition-transform hover:scale-[1.02]">
//               {/* Avatar */}
//               <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-white shadow-md">
//                 <img 
//                   src={websiteData.profileImage || "/api/placeholder/400/400"} 
//                   alt={websiteData.name} 
//                   className="w-full h-full object-cover"
//                 />
//               </div>
              
//               {/* Name and Expertise */}
//               <div className="text-center">
//                 <h1 className="text-2xl font-bold mb-1 text-green-900">{websiteData.name}</h1>
//                 <p className="text-green-600 font-medium mb-3">{websiteData.title || websiteData.profession || "Coach"}</p>
                
//                 {/* Expertise Tags */}
//                 {renderExpertiseTags()}
//               </div>
              
//               {/* Bio */}
//               <p className="text-gray-600 text-center my-4">{websiteData.bio}</p>
              
//               {/* Booking Button */}
//               <div className="w-full mt-4 mb-6">
//                 {renderBookingButton()}
//               </div>
              
//               {/* Social Icons */}
//               <div className="flex justify-center space-x-3 mt-2">
//                 {renderSocialLinks()}
//               </div>
//             </div>
            
//             {/* Contact Information */}
//             <div className="bg-white rounded-2xl shadow-md p-6 mt-6">
//               <h3 className="text-lg font-semibold text-green-900 mb-4">Contact Information</h3>
//               {renderContactInfo()}
//             </div>
            
//             {/* Years Experience */}
//             {websiteData.yearsExperience && (
//               <div className="bg-white rounded-2xl shadow-md p-6 mt-6">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3">
//                     <Users className="w-5 h-5 text-green-600" />
//                   </div>
//                   <div>
//                     <p className="text-gray-700">
//                       <span className="font-medium">{websiteData.yearsExperience}</span> years of experience
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
          
//           {/* Right Column - Content */}
//           <div className="md:w-2/3">
//             {/* Tabs */}
//             <div className="bg-white rounded-2xl shadow-md mb-8">
//               <div className="flex border-b">
//                 <button 
//                   onClick={() => setActiveTab('services')}
//                   className={`flex-1 py-4 text-center font-medium ${activeTab === 'services' 
//                     ? 'text-green-600 border-b-2 border-green-600' 
//                     : 'text-gray-500 hover:text-gray-700'}`}
//                 >
//                   Services
//                 </button>
//                 <button 
//                   onClick={() => setActiveTab('testimonials')}
//                   className={`flex-1 py-4 text-center font-medium ${activeTab === 'testimonials' 
//                     ? 'text-green-600 border-b-2 border-green-600' 
//                     : 'text-gray-500 hover:text-gray-700'}`}
//                 >
//                   Testimonials
//                 </button>
//               </div>
              
//               {/* Tab Content */}
//               <div className="p-6">
//                 {renderActiveTabContent()}
//               </div>
//             </div>
            
//             {/* Map Section */}
//             {websiteData.location && (
//               <div className="bg-white rounded-2xl shadow-md p-6">
//                 <h3 className="text-lg font-semibold text-green-900 mb-4">Location</h3>
//                 <div className="flex items-start mb-4">
//                   <MapPin className="w-5 h-5 text-green-500 mr-2" />
//                   <span className="text-gray-700">{websiteData.location}</span>
//                 </div>
//                 {renderMapSection()}
//               </div>
//             )}
            
//             {/* Newsletter Signup */}
//             <div className="bg-gradient-to-r from-green-600 to-green-800 rounded-2xl p-6 text-white mt-8">
//               <h2 className="text-xl font-bold mb-2">Join My Newsletter</h2>
//               <p className="mb-4">Get weekly tips, insights, and exclusive offers delivered to your inbox.</p>
//               <div className="flex flex-col sm:flex-row gap-2">
//                 <input 
//                   type="email" 
//                   placeholder="Your email address" 
//                   className="flex-1 py-3 px-4 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-300"
//                 />
//                 <button className="bg-white text-green-700 font-bold py-3 px-6 rounded-lg hover:bg-green-100 transition-colors">
//                   Subscribe
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
      
//       {/* Footer */}
//       <footer className="bg-green-800 text-white py-12 mt-12">
//         <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="md:flex md:justify-between md:items-center">
//             <div className="mb-8 md:mb-0">
//               <div className="flex items-center">
//                 <h2 className="text-2xl font-light tracking-wider">KInOS</h2>
//                 <Star fill="currentColor" className="ml-2 w-4 h-4" />
//               </div>
//               <p className="mt-2 text-sm text-green-200">Operating System for Coaches</p>
//             </div>
            
//             <div>
//               <p className="text-green-200 text-sm">
//                 Want your own professional coaching profile?
//               </p>
//               <a 
//                 href="#" 
//                 className="inline-flex items-center mt-2 text-white hover:text-green-200 transition-colors"
//               >
//                 Get started today
//                 <ChevronRight className="w-4 h-4 ml-1" />
//               </a>
//             </div>
//           </div>
          
//           <div className="mt-8 pt-8 border-t border-green-700 md:flex md:items-center md:justify-between">
//             <p className="text-sm text-green-200">
//               &copy; {new Date().getFullYear()} KInOS. All rights reserved.
//             </p>
//             <div className="flex space-x-6 mt-4 md:mt-0">
//               <a href="#" className="text-green-200 hover:text-white transition-colors">
//                 <span className="sr-only">Twitter</span>
//                 <Twitter className="h-5 w-5" />
//               </a>
//               <a href="#" className="text-green-200 hover:text-white transition-colors">
//                 <span className="sr-only">Facebook</span>
//                 <Facebook className="h-5 w-5" />
//               </a>
//               <a href="#" className="text-green-200 hover:text-white transition-colors">
//                 <span className="sr-only">Instagram</span>
//                 <Instagram className="h-5 w-5" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </footer>
      
//       {/* Custom CSS for background pattern */}
//       <style>{`
//         .bg-pattern {
//           background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
//         }
        
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default PublicPreview;

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import app from '../firebase'; // Import the Firebase app instance
import { 
  Star, 
  MapPin, 
  Mail, 
  Phone, 
  Calendar, 
  Instagram, 
  Facebook, 
  Twitter, 
  Linkedin,
  Clock,
  DollarSign,
  ChevronRight,
  Globe,
  Users,
  ChevronLeft,
  ChevronUp
} from 'lucide-react';

const PublicPreview = () => {
  const { userName } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [websiteData, setWebsiteData] = useState(null);
  
  // Refs for scroll containers
  const servicesScrollRef = useRef(null);
  const testimonialsScrollRef = useRef(null);
  
  useEffect(() => {
    const fetchWebsite = async () => {
      console.log('Starting to fetch website data for username:', userName);
      setLoading(true);
      setError(null);
      try {
        // Use the imported app instance to get Firestore
        const db = getFirestore(app);
        console.log('Firestore instance created');
        
        // 1. Fetch userId from usernames collection
        console.log('Attempting to fetch from usernames collection:', userName);
        const usernameRef = doc(db, 'usernames', userName);
        const usernameSnap = await getDoc(usernameRef);
        console.log('Username document exists:', usernameSnap.exists());
        
        if (!usernameSnap.exists()) {
          console.log('Username not found in database');
          setError('This username does not exist.');
          setLoading(false);
          return;
        }
        
        const userId = usernameSnap.data().uid;
        console.log('Retrieved userId:', userId);
        
        // 2. Fetch published website from publishedWebsite collection
        console.log('Attempting to fetch from publishedWebsite collection:', userId);
        const publishedRef = doc(db, 'publishedWebsite', userId);
        const publishedSnap = await getDoc(publishedRef);
        console.log('Published website document exists:', publishedSnap.exists());
        
        if (!publishedSnap.exists()) {
          console.log('Published website not found for userId:', userId);
          setError('This coaching profile is not published yet.');
          setLoading(false);
          return;
        }
        
        // Process data - ensure all expected fields have values even if missing
        const data = publishedSnap.data();
        console.log('Raw published website data:', data);
        
        // Ensure socialLinks exists
        if (!data.socialLinks) {
          console.log('No socialLinks found, creating default structure');
          data.socialLinks = {
            facebook: data.facebook || '',
            instagram: data.instagram || '',
            twitter: data.twitter || '',
            linkedin: ''
          };
        }
        
        console.log('Final processed website data:', data);
        setWebsiteData(data);
      } catch (err) {
        console.error('Error fetching website data:', err);
        console.error('Error details:', {
          message: err.message,
          code: err.code,
          stack: err.stack
        });
        
        if (err.message && err.message.includes('Missing or insufficient permissions')) {
          console.log('Permission error detected');
          setError('This coaching profile is not available due to permission restrictions.');
        } else {
          console.log('Generic error occurred');
          setError('An error occurred while loading this profile.');
        }
      } finally {
        console.log('Fetch operation completed, setting loading to false');
        setLoading(false);
      }
    };
    
    if (userName) {
      console.log('Username parameter found, initiating fetch');
      fetchWebsite();
    } else {
      console.log('No username parameter found');
    }
  }, [userName]);

  // Helper function to render stars for ratings
  const renderStars = (rating = 5, maxRating = 5) => {
    return (
      <div className="flex items-center">
        {[...Array(maxRating)].map((_, index) => (
          <Star 
            key={index} 
            className={`w-4 h-4 ${index < rating ? 'text-amber-400 fill-amber-400' : 'text-gray-200'} mr-0.5`} 
          />
        ))}
        <span className="text-gray-500 text-sm ml-2">({rating}.0)</span>
      </div>
    );
  };

  // Render social media icons
  const renderSocialLinks = () => {
    // Check for socialLinks object first
    if (websiteData?.socialLinks) {
      const { instagram, facebook, twitter, linkedin } = websiteData.socialLinks;
      // Only render if at least one social link exists
      if (instagram || facebook || twitter || linkedin) {
        return (
          <div className="flex space-x-4">
            {instagram && (
              <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
                <Instagram className="h-5 w-5 text-green-600" />
              </a>
            )}
            {facebook && (
              <a href={`https://facebook.com/${facebook}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
                <Facebook className="h-5 w-5 text-green-600" />
              </a>
            )}
            {twitter && (
              <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
                <Twitter className="h-5 w-5 text-green-600" />
              </a>
            )}
            {linkedin && (
              <a href={`https://linkedin.com/in/${linkedin}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
                <Linkedin className="h-5 w-5 text-green-600" />
              </a>
            )}
          </div>
        );
      }
    }
    
    // Fallback to top-level social properties if socialLinks object isn't available
    const { instagram, facebook, twitter } = websiteData || {};
    // Only render if at least one direct social property exists
    if (instagram || facebook || twitter) {
      return (
        <div className="flex space-x-4">
          {instagram && (
            <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
              <Instagram className="h-5 w-5 text-green-600" />
            </a>
          )}
          {facebook && (
            <a href={`https://facebook.com/${facebook}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
              <Facebook className="h-5 w-5 text-green-600" />
            </a>
          )}
          {twitter && (
            <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noopener noreferrer" className="border border-green-300 rounded-full p-3 hover:bg-green-50 transition-colors transform hover:scale-110">
              <Twitter className="h-5 w-5 text-green-600" />
            </a>
          )}
        </div>
      );
    }
    
    return null;
  };

  // Render expertise areas as tags
  const renderExpertiseTags = () => {
    if (!websiteData?.expertiseAreas || websiteData.expertiseAreas.length === 0) return null;
    
    return (
      <div className="flex flex-wrap gap-2 mt-4">
        {websiteData.expertiseAreas.map((expertise, index) => (
          <span 
            key={index} 
            className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium"
          >
            {expertise.replace(/-/g, ' ')}
          </span>
        ))}
      </div>
    );
  };

  // Scroll handlers for carousel
  const scroll = (ref, direction) => {
    if (ref.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      ref.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  // Render the services section with horizontal scrolling
  const renderServices = () => {
    if (!websiteData?.services || websiteData.services.length === 0) {
      // If services aren't available, show mock services as a fallback
      const mockServices = [
        {
          id: '1',
          title: 'Personal Life Coaching',
          description: 'One-on-one sessions focused on achieving your personal goals and improving life satisfaction.',
          duration: '60 min',
          price: '$120'
        },
        {
          id: '2',
          title: 'Mental Health Support',
          description: 'Supportive sessions to help manage stress, anxiety, and develop coping strategies.',
          duration: '45 min',
          price: '$90'
        },
        {
          id: '3',
          title: 'Wellness Consultation',
          description: 'Holistic approach to improve your overall wellbeing and create sustainable healthy habits.',
          duration: '90 min',
          price: '$150'
        }
      ];
      
      return (
        <div className="relative">
          <h2 className="text-2xl font-bold text-green-800 mb-4">Services</h2>
          <div className="absolute right-0 top-3 flex space-x-2">
            <button 
              onClick={() => scroll(servicesScrollRef, 'left')} 
              className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
              aria-label="Scroll left"
            >
              <ChevronLeft className="w-5 h-5 text-green-700" />
            </button>
            <button 
              onClick={() => scroll(servicesScrollRef, 'right')} 
              className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
              aria-label="Scroll right"
            >
              <ChevronRight className="w-5 h-5 text-green-700" />
            </button>
          </div>
          <div 
            ref={servicesScrollRef}
            className="flex space-x-4 overflow-x-auto pb-6 snap-x snap-mandatory hide-scrollbar"
          >
            {mockServices.map((service) => (
              <div 
                key={service.id} 
                className="snap-start flex-none w-full sm:w-80 bg-white border border-green-200 rounded-xl shadow-md hover:shadow-lg transition-all transform hover:translate-y-[-2px] p-6"
              >
                <h3 className="text-xl font-medium text-green-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <div className="flex flex-wrap gap-6 mt-auto">
                  <div className="flex items-center text-gray-500 text-sm">
                    <Clock className="w-4 h-4 mr-2" />
                    {service.duration}
                  </div>
                  <div className="flex items-center text-gray-500 text-sm">
                    <DollarSign className="w-4 h-4 mr-2" />
                    {service.price}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
    
    return (
      <div className="relative">
        <h2 className="text-2xl font-bold text-green-800 mb-4">Services</h2>
        <div className="absolute right-0 top-3 hidden sm:flex space-x-2">
          <button 
            onClick={() => scroll(servicesScrollRef, 'left')} 
            className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-5 h-5 text-green-700" />
          </button>
          <button 
            onClick={() => scroll(servicesScrollRef, 'right')} 
            className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-5 h-5 text-green-700" />
          </button>
        </div>
        <div 
          ref={servicesScrollRef}
          className="flex space-x-4 overflow-x-auto pb-6 snap-x snap-mandatory hide-scrollbar"
        >
          {websiteData.services.map((service, index) => (
            <div 
              key={service.id || index} 
              className="snap-start flex-none w-full sm:w-80 bg-white border border-green-200 rounded-xl shadow-md hover:shadow-lg transition-all transform hover:translate-y-[-2px] p-6"
            >
              <h3 className="text-xl font-medium text-green-900 mb-2">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <div className="flex flex-wrap gap-6 mt-auto">
                {service.duration && (
                  <div className="flex items-center text-gray-500 text-sm">
                    <Clock className="w-4 h-4 mr-2" />
                    {service.duration}
                  </div>
                )}
                {websiteData.showPricing && service.price && (
                  <div className="flex items-center text-gray-500 text-sm">
                    <DollarSign className="w-4 h-4 mr-2" />
                    {service.price}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render the testimonials section with horizontal scrolling
  const renderTestimonials = () => {
    if (!websiteData?.testimonials || websiteData.testimonials.length === 0) {
      // If testimonials aren't available, show mock testimonials as a fallback
      const mockTestimonials = [
        {
          id: '1',
          name: 'Sarah Johnson',
          content: 'Dave helped me completely transform my approach to work-life balance. His guidance was exactly what I needed during a difficult career transition.',
          rating: 5
        },
        {
          id: '2',
          name: 'Michael Torres',
          content: 'The wellness program Dave created for me was perfectly tailored to my needs. I\'ve seen remarkable improvements in just a few months.',
          rating: 5
        },
        {
          id: '3',
          name: 'Jessica Kim',
          content: 'Working with Dave has been transformative for my mental health. His approach is compassionate, practical, and incredibly effective.',
          rating: 5
        }
      ];
      
      return (
        <div className="relative mt-12">
          <h2 className="text-2xl font-bold text-green-800 mb-4">Testimonials</h2>
          <div className="absolute right-0 top-3 flex space-x-2">
            <button 
              onClick={() => scroll(testimonialsScrollRef, 'left')} 
              className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
              aria-label="Scroll left"
            >
              <ChevronLeft className="w-5 h-5 text-green-700" />
            </button>
            <button 
              onClick={() => scroll(testimonialsScrollRef, 'right')} 
              className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
              aria-label="Scroll right"
            >
              <ChevronRight className="w-5 h-5 text-green-700" />
            </button>
          </div>
          <div 
            ref={testimonialsScrollRef}
            className="flex space-x-4 overflow-x-auto pb-6 snap-x snap-mandatory hide-scrollbar"
          >
            {mockTestimonials.map((testimonial) => (
              <div 
                key={testimonial.id} 
                className="snap-start flex-none w-full sm:w-80 bg-white border border-green-200 rounded-xl shadow-md hover:shadow-lg transition-all transform hover:translate-y-[-2px] p-6"
              >
                {renderStars(testimonial.rating)}
                <p className="text-gray-700 mt-3 italic">"{testimonial.content}"</p>
                <p className="text-green-900 font-medium mt-2">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      );
    }
    
    return (
      <div className="relative mt-12">
        <h2 className="text-2xl font-bold text-green-800 mb-4">Testimonials</h2>
        <div className="absolute right-0 top-3 hidden sm:flex space-x-2">
          <button 
            onClick={() => scroll(testimonialsScrollRef, 'left')} 
            className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-5 h-5 text-green-700" />
          </button>
          <button 
            onClick={() => scroll(testimonialsScrollRef, 'right')} 
            className="p-2 rounded-full bg-green-100 hover:bg-green-200 transition-colors"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-5 h-5 text-green-700" />
          </button>
        </div>
        <div 
          ref={testimonialsScrollRef}
          className="flex space-x-4 overflow-x-auto pb-6 snap-x snap-mandatory hide-scrollbar"
        >
          {websiteData.testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id || index} 
              className="snap-start flex-none w-full sm:w-80 bg-white border border-green-200 rounded-xl shadow-md hover:shadow-lg transition-all transform hover:translate-y-[-2px] p-6"
            >
              {renderStars(testimonial.rating)}
              <p className="text-gray-700 mt-3 italic">"{testimonial.content}"</p>
              <p className="text-green-900 font-medium mt-2">— {testimonial.name}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render the location map section
  const renderMapSection = () => {
    // Always show map if location exists
    if (!websiteData?.location) return null;
    
    return (
      <div className="mt-8 rounded-xl overflow-hidden">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201064.14562241943!2d-122.57606278434371!3d37.7576171830618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1683214547570!5m2!1sen!2s"
          width="100%" 
          height="300" 
          style={{border: 0}}
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Location Map"
          className="rounded-xl"
        ></iframe>
      </div>
    );
  };

  // Render booking button
  const renderBookingButton = () => {
    // Always show booking button if calendarBookingPage exists
    if (!websiteData?.calendarBookingPage) return null;
    
    return (
      <a 
        href={websiteData.calendarBookingPage}
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 py-3 bg-gradient-to-r from-green-600 to-green-800 text-white font-medium rounded-lg inline-flex items-center justify-center hover:shadow-lg transition-all w-full"
      >
        <Calendar className="w-5 h-5 mr-2" />
        Book a Session
      </a>
    );
  };

  // Render contact information
  const renderContactInfo = () => {
    // Always show contact info since we have these fields in the payload
    return (
      <div className="flex flex-col space-y-4">
        {websiteData?.email && (
          <a href={`mailto:${websiteData.email}`} className="flex items-center text-gray-700 hover:text-gray-900 group">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
              <Mail className="w-5 h-5 text-green-600" />
            </div>
            <span>{websiteData.email}</span>
          </a>
        )}
        {websiteData?.phone && (
          <a href={`tel:${websiteData.phone}`} className="flex items-center text-gray-700 hover:text-gray-900 group">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
              <Phone className="w-5 h-5 text-green-600" />
            </div>
            <span>{websiteData.phone}</span>
          </a>
        )}
        {websiteData?.website && (
          <a href={websiteData.website} target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-gray-900 group">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors">
              <Globe className="w-5 h-5 text-green-600" />
            </div>
            <span>Website</span>
          </a>
        )}
        {websiteData?.location && (
          <div className="flex items-center text-gray-700">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3">
              <MapPin className="w-5 h-5 text-green-600" />
            </div>
            <span>{websiteData.location}</span>
          </div>
        )}
      </div>
    );
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-green-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-green-50 flex flex-col items-center justify-center p-4">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-green-800 mb-2">Profile Unavailable</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <button 
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-green-600 text-white rounded-lg shadow-sm hover:bg-green-700 transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }

  // If no website data
  if (!websiteData) {
    return (
      <div className="min-h-screen bg-green-50 flex items-center justify-center p-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-green-800 mb-2">Coaching Profile Not Found</h2>
          <p className="text-gray-600">This coaching profile doesn't exist or hasn't been published yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Hero Section */}
      <header className="relative h-64 bg-gradient-to-r from-green-800 to-green-500 overflow-hidden text-white py-12">
        <div className="absolute inset-0 opacity-20 bg-pattern"></div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="md:w-2/3 mb-8 md:mb-0">
              <h1 className="text-4xl font-light tracking-tight mb-4">
                {websiteData.name}
              </h1>
              <h2 className="text-xl text-green-100 mb-6">
                {websiteData.title || websiteData.profession || "Professional Coach"}
              </h2>
              <p className="text-green-100 mb-8 max-w-lg">
                {websiteData.bio}
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="md:flex md:gap-8">
          {/* Left Column - Profile Info */}
          <div className="md:w-1/3 -mt-24 relative z-20 mb-8 md:mb-0">
            <div className="flex flex-col items-center bg-white rounded-2xl shadow-lg p-6 transform transition-transform hover:scale-[1.02]">
              {/* Avatar */}
              <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-white shadow-md">
                <img 
                  src={websiteData.profileImage || "/api/placeholder/400/400"} 
                  alt={websiteData.name} 
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Name and Expertise */}
              <div className="text-center">
                <h1 className="text-2xl font-bold mb-1 text-green-900">{websiteData.name}</h1>
                <p className="text-green-600 font-medium mb-3">{websiteData.title || websiteData.profession || "Coach"}</p>
                
                {/* Expertise Tags */}
                {renderExpertiseTags()}
              </div>
              
              {/* Bio */}
              <p className="text-gray-600 text-center my-4">{websiteData.bio}</p>
              
              {/* Booking Button */}
              <div className="w-full mt-4 mb-6">
                {renderBookingButton()}
              </div>
              
              {/* Social Icons */}
              <div className="flex justify-center space-x-3 mt-2">
                {renderSocialLinks()}
              </div>
            </div>
            
            {/* Contact Information */}
            <div className="bg-white rounded-2xl shadow-md p-6 mt-6">
              <h3 className="text-lg font-semibold text-green-900 mb-4">Contact Information</h3>
              {renderContactInfo()}
            </div>
            
            {/* Years Experience */}
            {websiteData.yearsExperience && (
              <div className="bg-white rounded-2xl shadow-md p-6 mt-6">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3">
                    <Users className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <p className="text-gray-700">
                      <span className="font-medium">{websiteData.yearsExperience}</span> years of experience
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          {/* Right Column - Content */}
          <div className="md:w-2/3">
            {/* Services Section - Card-based with horizontal scroll */}
            <div className="mb-10">
              {renderServices()}
            </div>
            
            {/* Testimonials Section - Card-based with horizontal scroll */}
            <div className="mb-10">
              {renderTestimonials()}
            </div>
            
            {/* Map Section */}
            {websiteData.location && (
              <div className="bg-white rounded-2xl shadow-md p-6 mt-12">
                <h3 className="text-lg font-semibold text-green-900 mb-4">Location</h3>
                <div className="flex items-start mb-4">
                  <MapPin className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">{websiteData.location}</span>
                </div>
                {renderMapSection()}
              </div>
            )}
            
            {/* Newsletter Signup */}
            <div className="bg-gradient-to-r from-green-600 to-green-800 rounded-2xl p-6 text-white mt-12">
              <h2 className="text-xl font-bold mb-2">Join My Newsletter</h2>
              <p className="mb-4">Get weekly tips, insights, and exclusive offers delivered to your inbox.</p>
              <div className="flex flex-col sm:flex-row gap-2">
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  className="flex-1 py-3 px-4 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-300"
                />
                <button className="bg-white text-green-700 font-bold py-3 px-6 rounded-lg hover:bg-green-100 transition-colors">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="bg-green-800 text-white py-12 mt-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="md:flex md:justify-between md:items-center">
            <div className="mb-8 md:mb-0">
              <div className="flex items-center">
                <h2 className="text-2xl font-light tracking-wider">KInOS</h2>
                <Star fill="currentColor" className="ml-2 w-4 h-4" />
              </div>
              <p className="mt-2 text-sm text-green-200">Operating System for Coaches</p>
            </div>
            
            <div>
              <p className="text-green-200 text-sm">
                Want your own professional coaching profile?
              </p>
              <a 
                href="#" 
                className="inline-flex items-center mt-2 text-white hover:text-green-200 transition-colors"
              >
                Get started today
                <ChevronRight className="w-4 h-4 ml-1" />
              </a>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-green-700 md:flex md:items-center md:justify-between">
            <p className="text-sm text-green-200">
              &copy; {new Date().getFullYear()} KInOS. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-green-200 hover:text-white transition-colors">
                <span className="sr-only">Twitter</span>
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-green-200 hover:text-white transition-colors">
                <span className="sr-only">Facebook</span>
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-green-200 hover:text-white transition-colors">
                <span className="sr-only">Instagram</span>
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Custom CSS for background pattern and scrollbar hiding */}
      <style>{`
        .bg-pattern {
          background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
        
        /* Hide scrollbar but maintain scroll functionality */
        .hide-scrollbar {
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE and Edge */
        }
        
        .hide-scrollbar::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        
        /* Card entrance animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Swipe indicator for mobile */
        .swipe-indicator {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 4px;
        }
        
        .swipe-indicator-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #e2e8f0;
          transition: background-color 0.3s ease;
        }
        
        .swipe-indicator-dot.active {
          background-color: #059669;
        }
        
        /* Card hover effects */
        .service-card, .testimonial-card {
          transition: all 0.3s ease;
        }
        
        .service-card:hover, .testimonial-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }
        
        /* Responsive adjustments */
        @media (max-width: 640px) {
          .service-card, .testimonial-card {
            width: 85vw;
          }
        }
      `}</style>
      
      {/* Back to top button */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-4 right-4 p-3 rounded-full bg-green-600 text-white shadow-lg hover:bg-green-700 transition-colors"
        aria-label="Back to top"
      >
        <ChevronUp className="w-5 h-5" />
      </button>
    </div>
  );
};

export default PublicPreview;